import { Context } from '@nuxt/types';
import { Data as CategoriesData } from '@root/modules/category/types/categories';
import categoryUrl from '@root/modules/category/utils/buildCategoryUrl';
import getChannelDomain from '@root/modules/channel/utils/getChannelDomain';

const errorMessage = {
  message: 'category.error.not_found',
  statusCode: 404,
};

const getCategoryPath = async (context: Context) => {
  const { app, store, error } = context;

  try {
    const { id } = app.$channelConfig('settings');
    const domain = getChannelDomain(id);
    const { category }: { category: CategoriesData } = store.getters['category/getTempData'];

    if (category) {
      const sameChannel = domain === category.channel.url;
      // Redirect if category doesn't belong to current channel
      if (!sameChannel) {
        const fakeDomainEnabled = context.$config.FAKE_DOMAIN_ENABLED;
        return categoryUrl({ category, domain, fakeDomainEnabled });
      }
    }
  } catch (e) {
    error(errorMessage);
  }

  return false;
};

export default getCategoryPath;
